import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Restaurant  = () => {

  const  servicesFaqData = [
    { 
        question: "What is restaurant printing, and what materials are included?    ", 
        answer: "Restaurant printing involves creating high-quality materials such as menu cards, promotional flyers, and branding elements tailored for food service businesses. It includes custom printing menu cards for dine-in and takeaway services and posters and table tents for promotions. These materials are essential for enhancing customer experience, building brand identity, and communicating menu offerings. From durable menus to visually appealing signage, restaurant printing effectively supports operational and marketing needs."
    },
    { 
        question: "What are the benefits of custom printing menu cards?   ", 
        answer: "Custom printing menu cards allows restaurants to create designs reflecting their brand identity and offerings. Customisation ensures that the menus align with the restaurant’s theme, enhancing the dining experience. High-quality printing techniques produce vibrant colours and sharp details, making menus visually appealing and easy to read. Customised menu cards are also durable, ensuring they withstand frequent handling in a busy dining environment. This combination of functionality and aesthetics makes custom menu printing a valuable tool for any restaurant."
    },
    { 
        question: "Can Printingy handle bulk orders for restaurant printing services?    ", 
        answer: "Yes, Printingy specialises in bulk restaurant printing services, providing cost-effective solutions for large-scale orders. Bulk printing reduces per-unit costs, making it an economical choice for restaurants with multiple locations or high-volume needs. Our advanced printing technology ensures consistent quality across all materials, regardless of the order size. We also offer quick turnaround times to ensure your menus and promotional materials are ready for use on schedule. Printingy’s reliable bulk printing services support your branding and operational needs efficiently."
    },
    { 
        question: "What materials are used for menu designing & printing?   ", 
        answer: "Our menu designing & printing services use premium materials such as laminated paper, synthetic waterproof paper, and textured cardstock. The laminated paper adds a protective layer, making menus resistant to spills and stains. Synthetic waterproof paper is durable and ideal for outdoor dining or high-traffic restaurants. Textured cardstock offers an elegant look, suitable for upscale establishments. These materials are carefully selected to enhance menus' durability and visual appeal, ensuring a professional and lasting impression."
    },
    { 
        question: "What industries and businesses benefit from restaurant printing services?  ", 
        answer: "Restaurants, cafes, food trucks, and catering services benefit significantly from restaurant printing services. Restaurants use custom menu cards and promotional materials to enhance customer experience and showcase their offerings. Cafes rely on these services for table tents, menu boards, and loyalty cards. Food trucks and catering services utilise printed materials for branding, takeout menus, and event promotions. High-quality printing supports marketing and operational efforts, making it an essential tool for the food service industry."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Restaurant');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Custom Restaurant Printing Services"
  description="High-quality restaurant printing, including menu cards, promotional materials, and branding. Bulk restaurant printing services, menu designing, and printing solutions."
  keywords="Printing for Restaurant,
Custom Printing Menu Cards,
Restaurant Printing Services,
Menu Designing & Printing,
Restaurant Menu Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Restaurants  </h1>
              <h2 className="text-muted">Customised printing solutions for menus, branding, and promotional materials </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Restaurants rely on high-quality printing for menus, promotional materials, and branding elements that create memorable customer experiences. Printingy specialises in Printing for Restaurants, offering reliable restaurant printing services tailored to meet your needs.</p>
          <p>Our services include custom printing menu cards with vibrant visuals and durable finishes, ensuring a professional appearance. We also provide menu design and printing, creating unique and visually appealing menus that align with your brand identity. Additionally, our restaurant menu printing solutions cover a variety of formats, including dine-in menus, takeaway menus, and promotional flyers, ensuring consistency and quality across all materials.</p> 
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Restaurant Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable printing for menus and promotional needs </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for Restaurant materials tailored to your branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk restaurant printing services with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised custom printing menu cards for a unique dining experience.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional menu designing & printing with premium materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant colours and sharp visuals for impactful presentations.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable menus designed to withstand frequent handling.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for restaurants, cafes, and food service providers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/restaurantimg.jpg" // Path relative to the public folder
                  alt="Professional printing for restaurant services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Restaurant Printing Delivered On Time  </h2>
            <h3 className="small-hed">Focus on serving great food while we handle your menu printing needs </h3>
            <p>At Printingy, we use advanced printing techniques and premium materials to deliver exceptional restaurant printing services. Whether for menu cards, promotional materials, or branding elements, our menu designing & printing ensures professional and visually engaging results.
            </p>
            <p>With a focus on quality and efficiency, Printingy guarantees timely delivery for all bulk and customised orders. Partner with us for reliable and impactful restaurant printing solutions that enhance customer experience.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Restaurant;
